/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Text } from './Text';
import { Title } from './Title';

const SubscriptionDisabledSuccess = () => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type={'successBlue'} />
      <Title>{t('SUBSCRIPTION_DISABLED_SUCCESS_MODAL__title')}</Title>
      <Text>{t('SUBSCRIPTION_DISABLED_SUCCESS_MODAL__desc')}</Text>
    </>
  );
};

export { SubscriptionDisabledSuccess };
